import { apiClient, type Paginated } from '@/core/api';
import type { LeaveStatus, LeaveType } from './constants';
import type { TimeOff, TimeOffInput } from './types';

export const BASE = '/hrm/time-off/';

export interface TimeOffListParams {
  page?: number;
  search?: string;
  employee?: number;
  status?: LeaveStatus;
  type?: LeaveType;
  starts_after?: string;
  starts_before?: string;
  /** DRF `OrderingFilter` value, e.g. `start_date` or `-start_date`. */
  ordering?: string;
}

export async function listTimeOff(params: TimeOffListParams = {}): Promise<Paginated<TimeOff>> {
  const { data } = await apiClient.get<Paginated<TimeOff>>(BASE, { params });
  return data;
}

/** Resolves by public_id (string, from the URL) or integer pk (ADR-041). */
export async function getTimeOff(id: string | number): Promise<TimeOff> {
  const { data } = await apiClient.get<TimeOff>(`${BASE}${id}/`);
  return data;
}

export async function createTimeOff(input: TimeOffInput): Promise<TimeOff> {
  const { data } = await apiClient.post<TimeOff>(BASE, input);
  return data;
}

export async function updateTimeOff(
  id: string | number,
  input: Partial<TimeOffInput>,
): Promise<TimeOff> {
  const { data } = await apiClient.patch<TimeOff>(`${BASE}${id}/`, input);
  return data;
}

export async function deleteTimeOff(id: string | number): Promise<void> {
  await apiClient.delete(`${BASE}${id}/`);
}

/** Approve a request (HR-role only — 403 otherwise). */
export async function approveTimeOff(id: string | number): Promise<TimeOff> {
  const { data } = await apiClient.post<TimeOff>(`${BASE}${id}/approve/`);
  return data;
}

/** Reject a request (HR-role only — 403 otherwise). */
export async function rejectTimeOff(id: string | number): Promise<TimeOff> {
  const { data } = await apiClient.post<TimeOff>(`${BASE}${id}/reject/`);
  return data;
}
